// tslint:disable:max-line-length
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var cianIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "55",
  viewBox: "0 0 38 55",
  children: /*#__PURE__*/_jsx("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "M21.507 12.962l.104.196 7.537 13.657 7.538-13.657.104-.214a9 9 0 0 0 1.054-4.041c0-3.689-2.208-6.995-5.552-8.314C28.948-.73 25.16.211 22.768 2.956 20.375 5.7 19.874 9.68 21.507 12.962zM29.2 4.985c1.573 0 2.989.98 3.584 2.48.595 1.499.251 3.22-.87 4.354a3.79 3.79 0 0 1-4.244.819c-1.445-.64-2.37-2.116-2.342-3.735.037-2.175 1.76-3.918 3.872-3.918zm3.268 37.23L38 47.915 31.12 55 19 42.5 6.88 55 0 47.914l19-19.55 6.95 7.14v-6.446h6.518v13.158z"
  })
});